export function createCustomEvent(type: string) {
    if (typeof (CustomEvent) === "function") {
        return new CustomEvent(type);
    }
    else {
        const event = document.createEvent("Event");
        event.initEvent(type, false, false);
        return event as CustomEvent;
    }
}